import { make } from "vuex-pathify";

// properties
const state = {
  open: false,
  newList: false,
  showCompleted: false,
  loading: false,
  menu: {
    open: false,
    tab: null,
  },
  menuPanel: null,
  source: "server",
  betaDays: 0,
  modal: {
    signIn: false,
    analytics: false,
    list: {
      new: {
        open: false,
      },
      edit: {
        open: false,
        list: null,
      },
      import: {
        open: false,
      },
      save: {
        open: false,
        list: null,
      },
    },
  },
};

const mutations = make.mutations(state);
const getters = {
  ...make.getters(state),
};
const actions = {};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
